import { HeaderSection } from '@/features/ap_payees/components/PayeeDetailDrawer/components/Common';
import { EmailReceivingMethod } from '@/features/ap_payees/components/PayeeDetailDrawer/components/InvoiceReceivingMethod/components/EmailReceivingMethod';
import { ProxyReceivingMethod } from '@/features/ap_payees/components/PayeeDetailDrawer/components/InvoiceReceivingMethod/components/ProxyReceipt';
import { WebReceivingMethod } from '@/features/ap_payees/components/PayeeDetailDrawer/components/InvoiceReceivingMethod/components/WebReceivingMethod';
import {
  AnchorItemKey,
  ReceivingMethodData,
} from '@/features/ap_payees/components/PayeeDetailDrawer/types';

import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from '../../styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  data?: ReceivingMethodData;
  isEditable?: boolean;
};
export const InvoiceReceivingMethod: FC<Props> = ({
  data,
  isEditable = false,
}) => {
  const { t } = useTranslation();
  const { proxyReceivingMethod, webReceivingMethod, emailReceivingMethod, id } =
    data || {};
  return (
    <div
      id={AnchorItemKey.RECEIVING_METHOD}
      className={cx(['sectionContainer', 'groupedSectionContainer'])}
      key='invoice-receiving-method-section-container'
    >
      <HeaderSection
        displayName={t('ap_payee_detail_drawer_receiving_method')}
      />
      <EmailReceivingMethod
        data={emailReceivingMethod}
        apPayeeId={id ?? ''}
        isEditable={isEditable}
      />
      {!!webReceivingMethod?.is_supplier_upload_setting_enabled && (
        <WebReceivingMethod data={webReceivingMethod} />
      )}
      {!!proxyReceivingMethod?.is_proxy_receipt_receiving_method_enabled && (
        <ProxyReceivingMethod data={proxyReceivingMethod} />
      )}
    </div>
  );
};
